import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function dailyLogReducer(
  state = initialState.dailyLogs,
  action
) {
  switch (action.type) {
    case types.LOAD_DAILY_LOGS_SUCCESS:
      return action.logs;

    case types.CREATE_DAILY_LOG_SUCCESS:
      return [...state, Object.assign({}, action.log)];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dailyLogReducer.js